import { API } from "../../utils/_HttpUtils";

const my_location = window.location.origin.replace("admin", "my");

const imapersonateUser = (impersonation_id) => new API(my_location)
    .send("POST", `/api/v1/impersonations/${impersonation_id}/user`);

export { imapersonateUser };
